export default __webpack_public_path__ + "static/media/getting-started.9cd55db2.png";